import { createActions, createReducer } from 'reduxsauce'

import DetalhesRecursoRecebidoService from '../../servicos/DetalhesRecursoRecebidoService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAdministradorPublicoRecursoRecebidoInicio: [],
    buscaAdministradorPublicoRecursoRecebidoSucesso: ['administradorPublicoRecursoRecebido'],
    buscaAdministradorPublicoRecursoRecebidoErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAdministradorPublicoRecursoRecebido = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAdministradorPublicoRecursoRecebidoInicio())
        let serv = new DetalhesRecursoRecebidoService()
        return serv
            .consultarParecerAdministrador(filtro)
            .then(response => dispatch(Creators.buscaAdministradorPublicoRecursoRecebidoSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAdministradorPublicoRecursoRecebidoErro(error)))
    }
}

const buscaAdministradorPublicoRecursoRecebidoInicio = (state = INITIAL_STATE, action) => ({ ...state, carregando: true, erro: null })

const buscaAdministradorPublicoRecursoRecebidoErro = (state = INITIAL_STATE, action) => ({ ...state, erro: action.erro, carregando: false })

const buscaAdministradorPublicoRecursoRecebidoSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.administradorPublicoRecursoRecebido, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_RECEBIDO_INICIO]: buscaAdministradorPublicoRecursoRecebidoInicio,
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_RECEBIDO_ERRO]: buscaAdministradorPublicoRecursoRecebidoErro,
    [Types.BUSCA_ADMINISTRADOR_PUBLICO_RECURSO_RECEBIDO_SUCESSO]: buscaAdministradorPublicoRecursoRecebidoSucesso,
})
